import axios from 'axios';
import {
  DATE_RANGE_TYPE,
  DATE_UNITS,
} from '../../components/StatelessComponent/SingleFilter/DateRangeFilter/DateRangeFilterType';
import { convertFromNewUiToQueryFormat } from '../../utils/FormatConverter/FilterConverterFromUiToQuery';

import type { SimplifiedQuantzResponseDto } from './dto';
import { mapDtoToModel } from './mapper';
import type { RecordingEvent } from './model/RecordingEvent';

type SiteId = number;

const API_ROOT = `/api/dashboard/v1/sites`;

function createEndpointPath(siteId: SiteId): string {
  return `${API_ROOT}/${siteId}/query`;
}

function isSuccess(response: SimplifiedQuantzResponseDto): boolean {
  return response.meta.success;
}

export async function getAllEvents(siteId: SiteId): Promise<RecordingEvent[]> {
  const path = createEndpointPath(siteId);

  const body = {
    query: {
      session_filters: convertFromNewUiToQueryFormat({
        dateRange: {
          type: DATE_RANGE_TYPE.RELATIVE,
          amount: 12,
          unit: DATE_UNITS.MONTHS,
        },
        filterList: [],
      }),
      operation: 'max',
      property: 'created',
      group_by: 'user_event_name',
      limit: 10000,
      order: 'desc',
    },
  };

  const response = await axios.post<SimplifiedQuantzResponseDto>(path, body);
  const dto: SimplifiedQuantzResponseDto = response.data;
  if (!isSuccess(dto)) {
    throw new Error(`Error retrieving quantz data: ${dto?.errors?.join(', ')}`);
  }
  return mapDtoToModel(dto);
}
